import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Client } from 'src/app/interfaces/client';
import { UserAdmin } from 'src/app/interfaces/user-admin';
import { SuperAdminService } from 'src/app/services/api/super-admin.service';
import { DownloadService } from 'src/app/services/download.service';
import { ErrorService } from 'src/app/services/error.service';
import { LoadingService } from 'src/app/services/loading.service';
import { UserService } from 'src/app/services/user.service';
import { PsInfoComponent } from './modals/ps-info/ps-info.component';

@Component({
    selector: 'app-ps-admin',
    templateUrl: './ps-admin.component.html',
    styleUrls: ['./ps-admin.component.scss']
})

export class PsAdminComponent implements OnInit, OnDestroy {

    public title : string = "Medimail Patient - Admin PS";

    displayedColumns: string[] = ['email', 'name', 'structure', 'actions'];

    //@ts-ignore
    public users: MatTableDataSource<UserAdmin>;
  
    //@ts-ignore
    @ViewChild('paginator') paginator: MatPaginator;

    //@ts-ignore
    @ViewChild(MatSort) sort: MatSort;

    public errorMessageListPS : string = '';
    public errorTypeListPS : string = '';

    public errorMessageLoadPS: string = '';
    public errorTypeLoadPS: string = '';

    public clients: Client[] = [];

    @ViewChild('uploadFileInput') fileInput!: ElementRef;

    resSuccess: string[] = [];
    resError: string[] = [];

    fileUpload: boolean = false;
    
    tabUpdated: boolean = false;

    //@ts-ignore
    subscription: Subscription;

    constructor(public userService: UserService, 
                public route: Router,
                private errorService: ErrorService,
                public superAdminService: SuperAdminService,
                private activatedRoute: ActivatedRoute,
                private modalService: NgbModal,
                private downloadService: DownloadService,
                public loader: LoadingService,
                private translate: TranslateService,
                private titleService: Title) 
    {
        
    }

    ngOnInit(): void
    {

        this.titleService.setTitle(this.title);

        this.clients = this.activatedRoute.snapshot.data.clients.content;

        this.loadTabPs();

        // Rafraîchissement toutes les minutes quand il y a une modification
        this.subscription = timer(0,30000).pipe(map(() => {
            if (!this.tabUpdated) {
                this.loadTabPs();
            }
        })).subscribe();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    loadTabPs() {
        this.superAdminService.getPs().subscribe((res) => {
            if (res.result == "SUCCESS") {
                this.users = new MatTableDataSource(res.content);
                setTimeout(() => this.users.paginator = this.paginator);
                this.users.sort = this.sort;
                this.users.filterPredicate = (data: UserAdmin, filter: string) => {
                    var structure = data.clients.map((client) => {
                        return client.name.trim().toLocaleLowerCase();
                    });

                    return data.email.trim().toLowerCase().includes(filter) || 
                           data.displayName!.trim().toLowerCase().includes(filter) ||
                           structure.join(';').includes(filter);
                    };
            } else {
                this.errorTypeListPS = res.result;
                this.errorMessageListPS = res.content;
            }
        }, (resError) => {
            this.errorService.errorType = "ERROR";
            this.errorService.errorMessage = resError.error.detail;
            this.route.navigate(['/error']);
        });

        this.tabUpdated = true;
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.users.filter = filterValue;
    }

    getClients(user: any) {
        var structure = user.clients.map((client: Client) => {
            return client.name.trim();
        });

        return structure.join(', ');
    }

    infoPS(ps: any) {
        const modalRef = this.modalService.open(PsInfoComponent, {size: 'lg', centered: true});
        modalRef.componentInstance.ps = ps;
        modalRef.componentInstance.clients = this.clients;
        modalRef.result.then((data) => {
            this.tabUpdated = false;     
        }, (reason) => {
            this.tabUpdated = false;
        })
    }

    sendPasswordReset(user: any) {
        this.superAdminService.resetPassword(user.id).subscribe((res) => {
                this.errorMessageListPS = res.content;
                this.errorTypeListPS = res.result;
        });
    }

    downloadLoadPS() {
        const filename = "loadps.xlsx";
        this.loader.show("OPEN.DOWNLOAD-ATTACHMENT", {filename :  filename});
        this.downloadService.downloadFile(filename).subscribe(blob => {
            const a = document.createElement('a')
            const objectUrl = URL.createObjectURL(blob)
            a.href = objectUrl
            a.download = filename;
            a.click();
            URL.revokeObjectURL(objectUrl);
        })
        this.loader.hide();
    }

    fileUpdate() {
        if (this.fileInput.nativeElement.files.length > 0) {
            this.fileUpload = true;
        } else {
            this.fileUpload = false;
        }
    }

    async loadPS(attachment: any) {
        if (attachment.files.length > 0) {
            //@ts-ignore
            Array.from(attachment.files).forEach((file: File) => {
                let fileReader = new FileReader();
                fileReader.onload = async (e) => {
                    let text = fileReader.result;
                    this.loader.show("SPINNER-LOADER.LOADPS", {filename : file.name});
                    const res = await this.superAdminService.loadPS(text, file.name);
                    this.loader.hide();
                    if (res.result == 'SUCCESS') {
                        this.tabUpdated = false;
                        this.resError = [];
                        this.resSuccess = [];
                        var line = 2;
                        for (const [key, loadPsResult] of Object.entries(res.content)) {
                            
                            if (loadPsResult) {
                                //@ts-ignore
                                for (const [resultPs, textResult] of Object.entries(loadPsResult)) {
                                    var msg = '[Ligne ' + line + '] ';
                                    if (resultPs == "SUCCESS") {
                                        //@ts-ignore
                                        var split = textResult.split("]");
                                        var msgs = split[1].trim().split(";");
                                        const psMail = msgs[msgs.length - 1];
                                        msgs.pop();
                                        this.translate.get(msgs, {ps: psMail}).subscribe(res => {
                                            for(const [errorName, errorValue] of Object.entries(res)) {
                                                msg = msg + errorValue + " ";
                                            }
                                            //@ts-ignore
                                            this.resSuccess.push(msg.trim());
                                        });
                                    } else {
                                        //@ts-ignore
                                        var split = textResult.split("]");
                                        var msgs = split[1].trim().split(";");
                                        const psMail = msgs[msgs.length - 1];
                                        msgs.pop();
                                        this.translate.get(msgs, {ps: psMail}).subscribe(res => {
                                            for(const [errorName, errorValue] of Object.entries(res)) {
                                                msg = msg + errorValue + " ";
                                            }
                                            //@ts-ignore
                                            this.resError.push(msg.trim());
                                        });
                                    }

                                }
                            }
                            line = line + 1;
                        }
                    } else {
                        this.errorMessageLoadPS = res.content;
                        this.errorTypeLoadPS = res.result;
                    }
                }
                fileReader.readAsDataURL(file);
            });
        } else {
            this.errorMessageLoadPS = "LOADPS.ERRORS.NO-FILE";
            this.errorTypeLoadPS = "ERROR";
        }
    }
}
